import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import translationEN from './locales/en/translation.json'

export const SUPPORTED_LANGUAGES = [
  {
    code: 'en',
    name: 'English'
  }
]

const resources = {
  en: {
    translation: translationEN
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map(item => item.code),
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
      wait: true
    }
  }, () => {
    document.documentElement.lang = i18n.language || 'en';
  });

i18n.isEnglish = () => i18n.language === 'en'

export default i18n;
